import React, { FC } from 'react'
import { graphql } from 'gatsby'
import { Box, Container, Text, SanityImageProps } from '@mode/components'
import { CSS } from '@stitches/react'
import Image from 'gatsby-plugin-sanity-image';

type LogosProps = {
  heading?: string;
  background?: string;
  logos?: SanityImageProps;
  css?: CSS
  style?: 'left' | 'center';
}

export const HomeLogos: FC<LogosProps> = ({ heading, logos, background, style = 'left' }) => {
  return (
    <Box
      css={{
        color: background ? '$g1' : '$g5',
        pt: '$sm',
        pb: style === 'center' ? '$sm' : 0,
        background: background ?? 'transparent',
        '@md': {
          pt: '$md',
          pb: style === 'center' ? '$md' : 0,
        },
        ...CSS
      }}
    >
      <Container>
        <Text textStyle={style === 'center' ? "h4" : "h2"} css={{ mb: style === 'center' ? '$md' : '$sm', textAlign: style }}>{heading}</Text>
        <Box css={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
          {logos.map((logo, index) => {
            return (
              <Box
                key={logo.asset._id}
                css={{
                  width: '50%',
                  marginBottom: '$sm',
                  display: 'flex',
                  justifyContent: index % 2 === 0 ? 'flex-start' : 'flex-end',
                  '@md': {
                    width: 'auto',
                    marginBottom: 0,
                    justifyContent: 'flex-start'
                  }
                }}
              >
                {logo &&
                  <Box css={{ maxWidth: '125px', display: 'flex', alignItems: 'center', '@md': { maxWidth: '200px' } }}>
                    <Image {...logo} alt={logo.alt ?? ''} />
                  </Box>
                }
              </Box>
            )
          })}
        </Box>
      </Container>
    </Box>
  )
}

export const query = graphql`
  fragment LogosContent on Logos {
    _key
    heading
    background
    style
    logos {
      ...ImageWithPreview
    }
  }
`